function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(2 2)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  fill: "#C8C8C9",
  width: 20,
  height: 20,
  rx: 10
}), React.createElement("path", {
  d: "M14.854 6.16a.472.472 0 00-.708 0l-5.99 6.525-2.302-2.508a.472.472 0 00-.708 0 .58.58 0 000 .77l2.657 2.894a.472.472 0 00.707 0l6.344-6.911a.58.58 0 000-.77z",
  stroke: "#FFF",
  strokeWidth: 0.3,
  fill: "#FFF",
  fillRule: "nonzero"
}));

var SvgIcDetailsEditFieldTick = function SvgIcDetailsEditFieldTick(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "04859b6c6340c428738efedc434e80c0.svg";
export { SvgIcDetailsEditFieldTick as ReactComponent };